import { render, staticRenderFns } from "./HeadingWidget.vue?vue&type=template&id=14260e86&"
import script from "./HeadingWidget.vue?vue&type=script&lang=js&"
export * from "./HeadingWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14260e86')) {
      api.createRecord('14260e86', component.options)
    } else {
      api.reload('14260e86', component.options)
    }
    module.hot.accept("./HeadingWidget.vue?vue&type=template&id=14260e86&", function () {
      api.rerender('14260e86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/HeadingWidget.vue"
export default component.exports